const elementInternals = new WeakMap<HTMLElement, ElementInternals>();

export function setElementInternals(
  el: HTMLElement,
  internals: ElementInternals,
): void {
  elementInternals.set(el, internals);
}

export function getElementInternals(
  el: HTMLElement | undefined,
): ElementInternals | undefined {
  return el && elementInternals.get(el);
}
